import React, { Component } from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import PropTypes from 'prop-types';

// styles
import * as styles from './OMDropdown.scss';
import isDescendant from '../../../utils/isDescendant';

class OMDropdown extends Component {
  state = {
    isCollapsed: false
  };

  componentWillMount() {
    if (global && global.window) {
      window.addEventListener('mouseup', this.handleClick);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.handleClick);
  }

  getRef = (ref) => { this.wrapper = ref; };

  handleClick = (evt) => {
    if (!this.state.isCollapsed || isDescendant(this.wrapper, evt.target)) {
      return undefined;
    }

    return this.setState({ isCollapsed: false });
  };

  handleSelect = (evt) => {
    const id = get(evt, 'currentTarget.dataset.id');
    this.props.handleSelect(id);
  };

  toggleCollapse = () => this.setState({ isCollapsed: !this.state.isCollapsed });

  renderOption = ({ id, label }) => (
    <div
      key={id}
      data-id={id}
      onClick={this.handleSelect}
      className={cx(
        styles.option,
        { [styles.selected]: id === (this.props.selectedOption && this.props.selectedOption.id) }
      )}
    >
      {label}
    </div>
  );

  renderArrow = () => this.props.isTab && (
    <span className="icon icon-caret-down" />
  );

  render() {
    const { isTab, selectedOption } = this.props;
    return (
      <div
        className={cx(
          styles.wrapper,
          { [styles.opened]: this.state.isCollapsed },
          { [styles.tab]: isTab },
          { [styles.selectedTab]: isTab && !!selectedOption },
        )}
        onClick={this.toggleCollapse}
        ref={this.getRef}
      >
        <div className={styles.placeholder}>
          {!isTab && <div>{selectedOption.label}</div>}
          <div>{this.props.callToAction}{this.renderArrow()}</div>
        </div>
        <div className={styles.optionsWrapper}>
          {this.props.options.map(this.renderOption)}
        </div>
      </div>
    );
  }
}

OMDropdown.propTypes = {
  options: PropTypes.array,
  handleSelect: PropTypes.func,
  callToAction: PropTypes.string,
  selectedOption: PropTypes.object,
  isTab: PropTypes.bool
};

export default OMDropdown;
